export default __webpack_public_path__ + "static/media/openraise_0002_thumb.2eb6fda5.jpg";